import { useQuery } from '@tanstack/react-query';
import showToast from '../components/ToastComponent';
import { getProductFormulation } from '../service/getProductFormulation';
import { ProductFormulationResult } from '../interface/interface';

export const getProductFormulations = (token?: string) => {
  const { data: formulation, isLoading: isFormLoading } = useQuery({
    queryKey: ['productFormulation', token],
    enabled: !!token,
    queryFn: async () => {
      const result = await getProductFormulation(token!);

      if (typeof result === 'number') {
        showToast({
          message: 'Unable to fetch product formulation!',
          type: 'error',
        });
        return [];
      }

      return result
        .filter((e: ProductFormulationResult) =>
          Boolean(e?.productFormulationName),
        )
        .map((e) => ({
          label: e.productFormulationName,
          value: e.productFormulationName,
        }));
    },
  });

  return { formulation, isFormLoading };
};
